import { render, staticRenderFns } from "./SACRedirect.vue?vue&type=template&id=dc2a1050&scoped=true"
import script from "./SACRedirect.vue?vue&type=script&lang=js"
export * from "./SACRedirect.vue?vue&type=script&lang=js"
import style0 from "./SACRedirect.vue?vue&type=style&index=0&id=dc2a1050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2a1050",
  null
  
)

export default component.exports